import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import './Leaderboard.css';
import { FaTrophy, FaFire, FaMedal, FaStar } from 'react-icons/fa';

const Leaderboard = () => {
  const [leaderboardData, setLeaderboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeType, setActiveType] = useState('xp');
  const [activeTimeframe, setActiveTimeframe] = useState('all');
  const { userInfo } = useSelector((state) => state.userLogin);

  const fetchLeaderboard = async (type, timeframe) => {
    setLoading(true);
    try {
      const config = userInfo?.token ? {
        headers: { Authorization: `Bearer ${userInfo.token}` }
      } : {};
      
      const { data } = await axios.get(
        `https://api.andrewslearning.com/api/leaderboard/?type=${type}&timeframe=${timeframe}&limit=20`,
        config
      );
      
      setLeaderboardData(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboard(activeType, activeTimeframe);
  }, [activeType, activeTimeframe]);

  const getIcon = (rank) => {
    if (rank === 1) return <FaTrophy className="rank-icon gold" />;
    if (rank === 2) return <FaMedal className="rank-icon silver" />;
    if (rank === 3) return <FaMedal className="rank-icon bronze" />;
    return <span className="rank-number">#{rank}</span>;
  };

  const getValueDisplay = (type, item) => {
    switch (type) {
      case 'xp':
        return `${item.value.toLocaleString()} XP`;
      case 'level':
        return `Level ${item.value}`;
      case 'streak':
        return `${item.value} days`;
      case 'achievements':
        return `${item.value} badges`;
      default:
        return item.value;
    }
  };

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <h1>Leaderboards</h1>
        <p>See how you rank among other learners!</p>
      </div>

      <div className="leaderboard-controls">
        <div className="type-selector">
          <button 
            className={activeType === 'xp' ? 'active' : ''} 
            onClick={() => setActiveType('xp')}
          >
            XP Points
          </button>
          <button 
            className={activeType === 'level' ? 'active' : ''} 
            onClick={() => setActiveType('level')}
          >
            Level
          </button>
          <button 
            className={activeType === 'streak' ? 'active' : ''} 
            onClick={() => setActiveType('streak')}
          >
            <FaFire /> Streak
          </button>
          <button 
            className={activeType === 'achievements' ? 'active' : ''} 
            onClick={() => setActiveType('achievements')}
          >
            <FaTrophy /> Achievements
          </button>
        </div>

        {activeType === 'xp' && (
          <div className="timeframe-selector">
            <button 
              className={activeTimeframe === 'weekly' ? 'active' : ''} 
              onClick={() => setActiveTimeframe('weekly')}
            >
              This Week
            </button>
            <button 
              className={activeTimeframe === 'monthly' ? 'active' : ''} 
              onClick={() => setActiveTimeframe('monthly')}
            >
              This Month
            </button>
            <button 
              className={activeTimeframe === 'all' ? 'active' : ''} 
              onClick={() => setActiveTimeframe('all')}
            >
              All Time
            </button>
          </div>
        )}
      </div>

      {leaderboardData?.user_rank && (
        <div className="user-rank-banner">
          <FaStar className="star-icon" />
          <span>Your Rank: #{leaderboardData.user_rank}</span>
        </div>
      )}

      <div className="leaderboard-list">
        {loading ? (
          <div className="loading">Loading leaderboard...</div>
        ) : (
          leaderboardData?.leaderboard?.map((item, index) => (
            <div 
              key={index} 
              className={`leaderboard-item ${item.is_current_user ? 'current-user' : ''}`}
            >
              <div className="rank-section">
                {getIcon(item.rank)}
              </div>
              
              <div className="user-section">
                <div className="user-avatar">
                  {item.avatar ? (
                    <img src={item.avatar} alt={item.username} />
                  ) : (
                    <div className="avatar-placeholder">
                      {item.username.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="user-info">
                  <div className="username">{item.username}</div>
                  <div className="user-level">Level {item.level}</div>
                </div>
              </div>
              
              <div className="value-section">
                {getValueDisplay(activeType, item)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Leaderboard;